import { FC } from 'react';

interface AnchorProps {
  id: string;
}

export const Anchor: FC<AnchorProps> = ({ id }: AnchorProps) => {
  return <div id={id} className="anchor" />;
};
